import { Outlet } from 'react-router-dom';
import Sidebar from '../components/feature/Sidebar';
import Header from '../components/feature/Header';
import QuickSaleButton from '../components/feature/QuickSaleButton';

export default function AppLayout() {
  return (
    <div className="flex h-screen bg-[#F8FAFC] overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
        <QuickSaleButton />
      </div>
    </div>
  );
}
